const utilityHelpers = {
  removeTask: (taskList, taskToRemove) => taskList.filter(task => task.id !== taskToRemove.id),
  editTask: (taskList, taskToEdit) => taskList.map(task => task.id === taskToEdit.id ? taskToEdit : task)
};

export default utilityHelpers;